export default "__VITE_ASSET__CESogY_X__"